import {ACTION_TYPES} from 'Utils/constants';
import {
    ACTION,
    detectEventSource,
    detectUtmParams,
    getDeviceId,
    trackEvent,
    TYPE,
} from 'Utils/insights';

const trackInsightsEvent = (key, options, getState) => {
    if (
        ((key === 'featureDetailsCard' || key === 'featureSummary') &&
            (options.item?.properties?.tenantId || options.item?.properties?.featureId)) ||
        (key === 'promotionsDetailsCard' && options.item?.id) ||
        (key === 'eventDetails' && options.item?.id)
    ) {
        const state = getState();
        const additionalParams = {
            sourceDeviceId:
                state.device.deviceType === 'EXPLORER'
                    ? getDeviceId()
                    : state.pageState.layout.config.digitalSignId,
        };
        const utmParams = detectUtmParams(state);
        if (utmParams) {
            additionalParams.message = JSON.stringify(utmParams);
        }

        const payload = {
            action: ACTION.VIEW,
            source: detectEventSource(state),
            additionalParams,
        };

        switch (key) {
            case 'featureDetailsCard':
            case 'featureSummary':
                if (options.item?.properties?.tenantId) {
                    payload.type = TYPE.TENANT;
                    payload.typeId = options.item.properties.tenantId;
                } else {
                    payload.type = TYPE.LOCATION;
                    payload.typeId = options.item.properties.featureId;
                }
                break;
            case 'promotionsDetailsCard':
                payload.type = TYPE.PROMOTION;
                payload.typeId = options.item.id;
                break;
            default:
                payload.type = TYPE.EXPERIENCE;
                payload.typeId = options.item.id;
                break;
        }
        trackEvent(payload);
    }
};

const navigate = (key, options = {}) => (dispatch, getState) => {
    trackInsightsEvent(key, options, getState);
    dispatch({
        type: ACTION_TYPES.NAVIGATE,
        data: {
            key,
            options,
        },
    });
    if (!options?.ignoreNavHistory) {
        dispatch({
            type: ACTION_TYPES.PUSH_NAVIGATION_HISTORY,
            data: {
                key,
                options,
            },
        });
    }
};

export default navigate;
